import React, { Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import Orders1688 from "../components/1688Orders/Orders";
import App from "../components/app";
import NotFound from "../components/notfound/NotFound";
import AutoOrderList from "../components/orders/auto-order/AutoOrderList";
import OrderList from "../components/orders/OrderList";
import ReturnLists from "../components/orders/returns/ReturnLists";
import ShippingTable from "../components/orders/shipping/shippingTable";
import UpdateOrder from "../components/orders/updateOrder";
import AdminOrdersTable from "../components/Shipping/AdminOrdersTable";
const LayoutRoutes = () => {
    return (
        <Fragment>
            <Routes>
                <Route element={<App />}>
                    <Route
                        path={`${process.env.PUBLIC_URL}/dashboard`}
                        element={<AdminOrdersTable />}
                    />
                    <Route
                        path={`${process.env.PUBLIC_URL}/1688_orders`}
                        element={<Orders1688 />}
                    />
                     <Route
                        path={`${process.env.PUBLIC_URL}/orders/admin`}
                        element={<OrderList />}
                    />
                     <Route
                        path={`${process.env.PUBLIC_URL}/orders/admin/shipping`}
                        element={<ShippingTable />}
                    />
                     <Route
                        path={`${process.env.PUBLIC_URL}/orders/admin/returns`}
                        element={<ReturnLists />}
                    />
                     <Route
                        path={`${process.env.PUBLIC_URL}/orders/admin/:id`}
                        element={<UpdateOrder />}
                    />
                      <Route
                        path={`${process.env.PUBLIC_URL}/orders/admin/:id`}
                        element={<AutoOrderList />}
                    />
                    <Route
                        path="*"
                        element={<NotFound />}
                    />
                </Route>
            </Routes>
        </Fragment>
    );
};

export default LayoutRoutes;
